/**
 * Canonical commercial unit identity shared by Pricing matching and the
 * Internal Pricing supplier selector. Display spelling stays untouched.
 */
export function normalisePricingUnitKey(unit) {
    const value = String(unit || '').trim().toLowerCase()
        .replace(/\bmetres?\b/g, 'meter')
        .replace(/\bmeters?\b/g, 'meter');
    if (!value) return '';
    if (/^(?:per\s*)?day(?:\s*rate)?$|^daily$/.test(value)) return 'per_day';
    if (/^(?:per\s*)?hour(?:ly)?(?:\s*rate)?$/.test(value)) return 'per_hour';
    return value.replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
}
